import React from 'react';
import { Box, Button, Stack, Typography, useTheme } from '@mui/material';
import { createElement } from 'react';
import { NewsWidgetProps } from '../types';
import { useGetNewsArticleHtmlByIdQuery } from 'src/queries/services/account';
import { Cog } from 'mdi-material-ui';
import { VigoTypography } from 'src/@vigo/vigo-typography';

import styles from './newsWidget.module.css';

const NewsWidget = ({ newsItem, onMouseOver, onMouseOut, openNewsModal, isActive }: NewsWidgetProps) => {
  const theme = useTheme();

  const { data, isFetching } = useGetNewsArticleHtmlByIdQuery(newsItem.id ?? '', {
    queryKeyOverride: [`newsfeedArticle-${newsItem.id}`, newsItem.id],
    enabled: Boolean(newsItem.id) && Boolean(isActive),
  })

  if (isFetching) {
    return (
      <Box sx={{ width: '100%', height: '40vh', display: 'grid', placeContent: 'center'}}>
        <Cog
          htmlColor={theme.palette.mode === 'dark' ? '#1e1e1e' : theme.palette.primary.dark}
          sx={{
            justifySelf: 'center',
            fontSize: '5rem',
            animation: 'spin 3s linear infinite',
            '@keyframes spin': {
              '0%': {
                transform: 'rotate(0deg)'
              },
              '100%': {
                transform: 'rotate(360deg)'
              }
            }
          }}
        />
        <VigoTypography value="Loading newsfeed article ..." sx={{ fontSize: '1.3rem' }} />
      </Box>
    )
  }

  return (
    <>
      <Stack className={styles.newsfeed__container} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        <Box
          sx={{ backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e1e' }}
          className={`${styles.news_header} ${
            newsItem?.internal ? styles.news_header__depot : styles.news_header__network
          }`}>
          <Box className={styles.news_header_category__container}>
            <Typography sx={{ textAlign: 'left', marginLeft: '10px', fontSize: '1.5rem', fontWeight: '700' }}>
              {'Newsfeed'}
            </Typography>
          </Box>
        </Box>
        <Box
          className={styles.news_body}
          sx={{
            '::-webkit-scrollbar': {
              width: '5px',
              height: '5px',
              backgroundColor: '#acacac'
            },
            '::-webkit-scrollbar-thumb': {
              backgroundColor: '#2b2d42',
              borderRadius: '5px'
            }
          }}>
          <div className={styles.sampleNewsLetter__container}>
            {data &&
              createElement('div', {
                className: `${styles.htmlContainer}`,
                dangerouslySetInnerHTML: { __html: data }
              })}
          </div>
        </Box>

        <Box className={`${styles.news_readmore__container} `}>
          <Button className={styles.news_readmore_link} onClick={openNewsModal} id="huhu">
            Read More
          </Button>
        </Box>
      </Stack>
    </>
  );
};

export default React.memo(NewsWidget);
